<!-- logos -->
<div id="navBar">
  <div class="navbar_item navbar_brand">
    <a routerLink="/" class="navbar-brand" aria-label="Passe Livre LATAM">
      <div id="navbar-logoContainer">
        <div class="navbar-svg-container">
          <div class="navbar-image">
            <img src="assets/images/logo-airlines-white.svg" width="100%" height="100%" class="navbar-svg-content" alt="">
          </div>
        </div>
      </div>
    </a>
  </div>

  <div class="navbar_item profile">
    <button type="button" class="profile-action"
      [class.change-bp]="isAdmin"
      [disabled]="!isAdmin"
      [attr.aria-label]="isAdmin ? 'Alterar BP' : 'Foto de Perfil'"
      (click)="openDialogChangeBp()"
      [title]="isAdmin ? 'Alterar BP': ''">
      @if (hasPhoto) {
        <img class="profile-photo_user" [src]="photo" referrerpolicy="no-referrer"
          (error)="onPhotoError()" alt="Foto de Perfil"/>
      } @else {
        <span class="profile-photo_placeholder" role="img" aria-label="Foto de Perfil">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="currentColor"/>
          </svg>
        </span>
      }
    </button>
    @if (name) {
      <button type="button" class="profile-action profile-name_container"
        [class.edit-external_crew]="isExternal"
        [disabled]="!isExternal"
        [attr.aria-label]="isExternal ? 'Alterar Dados de ' + name : null"
        (click)="openDialogEditExternalCrew()"
        [title]="isExternal ? 'Alterar Dados': ''">
        <span class="profile-name">{{ name }}</span>
      </button>
    }
  </div>

  <div class="navbar_item item-logout">
    <button type="button" class="logout" (click)="logout()" title="Sair da conta">
      <span class="logout-icon_container" aria-hidden="true">
        <img class="logout-icon" src="assets/images/logout.svg" alt=""/>
      </span>
      <span>Sair</span>
    </button>
  </div>
</div>
